import { useQuery } from "@apollo/client";
import { GET_SEARCH_MATERIALS } from "../../../../lib/apollo/gql/artGqls";

function useArtSearchMaterialSelector() {
  const { data, loading } = useQuery(GET_SEARCH_MATERIALS);

  return {
    models: {
      data: data?.getSearchMaterials,
      loading,
    },
  };
}

export default useArtSearchMaterialSelector;
